<template>
    <div class="container-outline">
        <div class="register">
            <div class="title">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 4, title: 'data pribadi' }" />
            </div>
            <div class="content-register">
                <div class="container">
                    <p class="sub-title">APLIKASI PEMBUKAAN REKENING TRANSAKSI</p>
                    <form @submit.prevent="registerKYC" autocomplete="on">
                        <div class="form-group">
                            <label for="">Kode Nasabah</label>
                            <input type="text" class="form-input" v-model="nasabah_code" readonly />
                        </div>
                        <div class="form-group">
                            <label for="">Nama Lengkap *</label>
                            <input type="text" class="form-input" placeholder="Sesuai dengan KTP" v-model="form.fullname" maxlength="50" />
                        </div>
                        <div class="form-group">
                            <label>Tempat/tanggal lahir *</label>
                            <input
                                type="text"
                                class="form-input tempat"
                                placeholder="Nama kota Anda lahir"
                                v-model="form.place_of_birth"
                                required
                                maxlength="25"
                                @keyup="form.place_of_birth = form.place_of_birth.replace(/[^a-zA-Z\s]/g, '')"
                            />
                            <label class="input-button" data-browse="Upload file">
                                <input type="date" class="form-input birtday" placeholder="17/07/1995" v-model="form.date_of_birth" :max="today" required />
                            </label>
                        </div>
                        <div class="form-group">
                            <label for="">No Identitas/Tanggal terbit *</label>
                            <input type="text" v-model="form.identity_type" class="form-input identitas" />
                            <input
                                type="text"
                                :class="{
                                    'form-input-succes': data_keypress == 200,
                                    'form-ktp-bagi': bankType == 'BAGI',
                                }"
                                class="form-input form-ktp-bagi"
                                ref="no_identitas"
                                placeholder="Masukkan NIK anda"
                                v-model="form.ktp_no"
                                @keyup="form.ktp_no = form.ktp_no.replace(/[^\d]/g, '')"
                                required
                                maxlength="16"
                                minlength="16"
                            />
                            <input
                                type="date"
                                class="form-input tanggal-aktif"
                                v-model="form.ktp_issued_date"
                                name="setTodaysDate"
                                placeholder="Tanggal Terbit"
                                required
                                :max="today"
                            />
                            <div v-show="data_keypress == 403" class="error konfirmasi-ktp">
                                E-KTP tidak valid
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">No NPWP *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Masukan no npwp"
                                v-model="$v.form.npwp_no.$model"
                                @keyup="form.npwp_no = form.npwp_no.replace(/[^\d]/g, '')"
                                required
                            />
                            <div v-if="$v.form.npwp_no.$error">
                                <div class="form-error" v-if="!$v.form.npwp_no.minLength">
                                    No NPWP minimal 16 karakter
                                </div>
                                <div class="form-error" v-if="!$v.form.npwp_no.maxLength">
                                    No NPWP maksimal 20 karakter
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="">Jenis Kelamin *</label>
                            <div class="radio">
                                <label class="trv-radio label-radio" v-for="(data, i) in gender" :key="i">
                                    <input type="radio" name="gender" v-model="form.gender_code" :value="data.code" required />
                                    <span class="outer"><span class="inner"></span></span>
                                    {{ data.name }}
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">Status Perkawinan *</label>
                            <select v-model="marital_status" required @change="selectMarriage">
                                <option value="" disabled selected>Pilih Status Perkawinan</option>
                                <option v-for="(data, i) in statusMarriage" :key="i" :value="{ value: data.name, id: data.code }">{{ data.name }}</option>
                            </select>
                        </div>

                        <div class="form-group" v-show="marital_status.value == 'Menikah' || marital_status.value == 'menikah'">
                            <label for="">Nama suami/istri (Opsional)</label>
                            <input type="text" class="form-input" placeholder="Nama lengkap suami / istri anda" v-model="form.partners_name" />
                        </div>
                        <div class="form-group">
                            <label for="">Nama Ibu Kandung *</label>
                            <input type="text" placeholder="masukkan nama ibu kandung" v-model="form.mothers_name" class="form-input" required />
                        </div>

                        <div class="form-group">
                            <label for="">Alamat Rumah *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Alamat lengkap rumah anda"
                                v-model="form.identity_address.address"
                                required
                                maxlength="80"
                                @keyup="form.identity_address.address = form.identity_address.address.replace(/[^a-zA-Z0-9\s,.-]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Provinsi *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Profinsi sesuai ktp"
                                v-model="form.identity_address.province"
                                required
                                @keyup="form.identity_address.province = form.identity_address.province.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kota *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Kota sesuai ktp"
                                v-model="form.identity_address.regency"
                                required
                                @keyup="form.identity_address.regency = form.identity_address.regency.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kecamatan *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Kecamatan sesuai ktp"
                                v-model="form.identity_address.district"
                                required
                                @keyup="form.identity_address.district = form.identity_address.district.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kelurahan *</label>
                            <input
                                type="text"
                                class="form-input kecamatan"
                                placeholder="Kelurahan sesuai ktp"
                                v-model="form.identity_address.village"
                                required
                                @keyup="form.identity_address.village = form.identity_address.village.replace(/[^a-zA-Z\s]/g, '')"
                            />
                            <span class="rt-rw">RT*</span>
                            <input
                                type="text"
                                maxlength="3"
                                class="form-input input-rt-rw"
                                v-model="form.identity_address.neighborhood_no"
                                required
                                @keyup="form.identity_address.neighborhood_no = form.identity_address.neighborhood_no.replace(/[^\d]/g, '')"
                            />
                            <span class="rt-rw rw">RW*</span>
                            <input
                                type="text"
                                maxlength="3"
                                class="form-input input-rt-rw"
                                v-model="form.identity_address.citizen_no"
                                required
                                @keyup="form.identity_address.citizen_no = form.identity_address.citizen_no.replace(/[^\d]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kodepos *</label>
                            <input
                                type="text"
                                class="form-input pos-telepon kode-pos"
                                placeholder="Masukkan kodepos"
                                v-model="form.identity_address.postcode"
                                required
                                @keyup="form.identity_address.postcode = form.identity_address.postcode.replace(/[^\d]/g, '')"
                                minlength="5"
                                maxlength="5"
                            />
                        </div>
                        <div class="form-group">
                            <label for="">No Telepon Rumah</label>
                            <input
                                type="text"
                                class="form-input pos-telepon"
                                placeholder="8133370...."
                                @keyup="form.identity_address.telephone = form.identity_address.telephone.replace(/[^\d]/g, '')"
                                v-model="form.identity_address.telephone"
                                maxlength="18"
                                minlength="6"
                            />
                        </div>
                        <div class="form-group">
                            <label for="">No Fax Rumah</label>
                            <input
                                type="text"
                                class="form-input pos-telepon"
                                placeholder="8133370...."
                                v-model="form.identity_address.fax"
                                @keyup="form.identity_address.fax = form.identity_address.fax.replace(/[^\d]/g, '')"
                                maxlength="18"
                                minlength="6"
                            />
                        </div>
                        <div class="form-group">
                            <label for="">No. Telp. Handphone *</label>
                            <input
                                type="text"
                                class="form-input pos-telepon"
                                placeholder="8133370...."
                                @keyup="numberOnly"
                                v-model="phone_number"
                                required
                                maxlength="18"
                                minlength="6"
                                readonly
                            />
                        </div>
                        <div class="form-group">
                            <label for="">Status Kepimilikan Rumah</label>
                            <select name="" id="" v-model="form.identity_address.ownership_status" required>
                                <option value="" selected disabled>Pilih setatus kepemilikan rumah</option>
                                <option value="pribadi">Pribadi</option>
                                <option value="keluarga">Keluarga</option>
                                <option value="sewa">Sewa</option>
                                <option value="lainnya">Lainnya</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="">Tujuan Pembukaan Rekening</label>
                            <select name="" id="" v-model="form.purpose_open_account_code" required>
                                <option value="" selected disabled>Pilih tujuan pembukan rekening</option>
                                <option v-for="(data, i) in purpose_open_type" :key="i" :value="data.code">{{ data.name }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="">Pengalaman investasi </label>
                            <div class="radio">
                                <label class="trv-radio label-radio" @change="changeStatusInvestmentExperience(true)"
                                    ><input type="radio" name="radios" :value="true" id="1" v-model="form.has_investment_experience" required /><span class="outer"
                                        ><span class="inner"></span></span
                                    >Ya</label
                                >
                                <label class="trv-radio label-radio" @change="changeStatusInvestmentExperience(false)">
                                    <input type="radio" v-model="form.has_investment_experience" name="radios" :value="false" id="1" required />
                                    <span class="outer">
                                        <span class="inner"></span>
                                    </span>
                                    Tidak
                                </label>
                            </div>
                        </div>
                        <div class="form-group" v-if="investmentExperienceStatus">
                            <label></label>
                            <input
                                type="text"
                                class="form-input other-choice"
                                placeholder="Masukkan pengalaman investasi anda"
                                v-model="form.investment_experience"
                            />
                        </div>

                        <div class="form-group">
                            <label for="" class="pernyataan-bappebti"
                                >Apakah Anda memiliki anggota keluarga yang bekerja di BAPPEBTI / Bursa Berjangka / Kliring Berjangka?
                            </label>
                            <div class="radio">
                                <label class="trv-radio label-radio" @click="form.has_futures_trading_family = true"
                                    ><input type="radio" name="family-bappebti" :value="true" id="1" v-model="form.has_futures_trading_family" required /><span
                                        class="outer"
                                        ><span class="inner"></span></span
                                    >Ya</label
                                >
                                <label class="trv-radio label-radio" @click="form.has_futures_trading_family = false">
                                    <input type="radio" v-model="form.has_futures_trading_family" name="family-bappebti" :value="false" id="2" required />
                                    <span class="outer">
                                        <span class="inner"></span>
                                    </span>
                                    Tidak
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="" class="pernyataan-bappebti">Apakah Anda telah dinyatakan pailit oleh Pengadilan? </label>
                            <div class="radio">
                                <label class="trv-radio label-radio" @click="form.has_bankrupt = true"
                                    ><input type="radio" name="has_bankrupt" :value="true" id="1" v-model="form.has_bankrupt" required /><span class="outer"
                                        ><span class="inner"></span></span
                                    >Ya</label
                                >
                                <label class="trv-radio label-radio" @click="form.has_bankrupt = false">
                                    <input type="radio" v-model="form.has_bankrupt" name="has_bankrupt" :value="false" id="2" required />
                                    <span class="outer">
                                        <span class="inner"></span>
                                    </span>
                                    Tidak
                                </label>
                            </div>
                        </div>

                        <div class="form-group form-checkbox" id="toggle-btn">
                            <input type="checkbox" class="checkbox" required v-model="form.has_confirm_costumer" :value="true" />
                            <label class="label--checkbox">
                                Dengan ini saya setuju atas seluruh DATA PRIBADI yang saya isi adalah BENAR dan sesuai dengan
                                <span class="ketentuan">Peraturan</span> yang berlaku
                            </label>
                        </div>

                        <div class="error" v-show="message == 400">
                            No KTP sudah terdaftar
                        </div>
                        <div class="button">
                            <router-link to="/disclosure1"><button class="btn-scondary">Sebelumnya</button></router-link>
                            <button class="btn-primer" type="submit">
                                <div v-show="isLoading == false">Selanjutnya</div>
                                <Loader v-show="isLoading" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Resiko from "../assets/filedownload/Resiko";
// import ProfilPerusahaan from "../assets/filedownload/ProfilPerusahaan";
import axios from "axios";
import Loader from "../assets/Loading";
import moment from "moment";

import { minLength, maxLength } from "vuelidate/lib/validators";
import HeadRegister from "./component/HeadRegister.vue";

export default {
    components: {
        // Resiko,
        // ProfilPerusahaan,
        Loader,
        HeadRegister,
    },

    data() {
        return {
            checkedStatement: false,
            selected: false,
            setuju: "",
            setuju2: "",
            selectedNpwp: "",
            full_name: "",
            birthday: "",
            ktp_no: "",
            phone_number: "",
            mothers_name: "",
            dataEducation: "",
            dataPlatform: [],
            nasabah_code: "",
            investmentExperienceStatus: "",
            form: {
                fullname: "",
                mothers_name: "",
                date_of_birth: "",
                ktp_no: "",
                ktp_issued_date: "",
                partners_name: "",
                place_of_birth: "",
                citizenship: "",
                identity_type: "",
                npwp_no: "",
                dependent_no: "",
                gender_code: "",
                marriage_code: "",
                purpose_open_account_code: "",
                investment_experience: "",
                identity_address: {
                    ownership_status: "",
                    address: "",
                    citizen_no: "",
                    neighborhood_no: "",
                    village: "",
                    district: "",
                    regency: "",
                    province: "",
                    postcode: "",
                    telephone: "",
                    fax: "",
                },
                has_futures_trading_family: null,
                has_bankrupt: null,
                has_confirm_costumer: false,
                has_set_trading_simulation: "",
                has_set_company_profile: "",
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                step: "customer",
                completeness_verification: "",
                disclosure_customer: "",
                disclosure_risk: "",
                disclosure_mandate: "",
            },
            modalShow: "",
            platform: "",
            message: "",
            province: [],
            cityKtp: [],
            cityDomisili: [],
            data_keypress: "",
            dataProvince: {
                code: "",
                id: "",
            },
            dataCity: "",
            dataProvinceDoms: {
                code: "",
                id: "",
            },
            dataCityDoms: {
                code: "",
                id: "",
            },
            dataDistrictsDoms: {
                code: "",
                id: "",
            },
            ifCheck: "",
            isLoading: false,
            identity: "",
            agama: "",
            statusMarriage: "",
            selectCityKtp: {
                code: "",
                id: "",
            },
            districtsKtp: "",
            selectSubDistrictsKtp: {
                code: "",
                id: "",
            },
            subDistricsKtp: "",
            gender: "",

            districtsDoms: "",
            subDistricsDoms: "",
            marital_status: {
                value: "",
                id: "",
            },
            identity_type: "",
            bankType: "",
            today: "",
            idCustomer: "",
            isueDate: "",
            purpose_open_type: "",
            typeDate: "text",
        };
    },
    validations: {
        form: {
            npwp_no: {
                minLength: minLength(16),
                maxLength: maxLength(20),
            },
            ktp_no: {
                minLength: minLength(16),
                maxLength: maxLength(16),
            },
        },
    },

    mounted() {
        var today = new Date();
        today.setFullYear(today.getFullYear());
        this.today = new Date().toISOString().split("T")[0];
        axios.get("/v2/user/profile").then((res) => {
            this.nasabah_code = res.data.data.user.account_code;
            this.phone_number = res.data.data.user.phonenumber;
        });
        // Get Agama
        axios.get("/v2/master_data/religion").then((res) => {
            this.agama = res.data.data;
        });

        // Get education
        axios.get("/v2/master_data/education").then((res) => {
            this.dataEducation = res.data.data;
        });

        // Get setatus perkawinan
        axios.get("/v2/master_data/marriage").then((res) => {
            this.statusMarriage = res.data.data;
        });

        // Get jenis kelamin
        axios.get("/v2/master_data/gender").then((res) => {
            this.gender = res.data.data;
        });

        axios.get("/v2/master_data/purpose_open_account").then((res) => {
            this.purpose_open_type = res.data.data;
        });

        // Get data KYC
        axios.get("/v2/kyc/customer").then((res) => {
            let customer = res.data.data.customer;
            localStorage.setItem("status_kyc", customer.state);
            this.idCustomer = customer._id;
            this.form.identity_address.address = customer.identity_address.address;
            this.form.identity_address.postcode = customer.identity_address.postcode;
            this.form.identity_address.neighborhood_no = customer.identity_address.neighborhood_no;
            this.form.identity_address.citizen_no = customer.identity_address.citizen_no;
            this.form.identity_address.village = customer.identity_address.village;
            this.form.identity_address.telephone = customer.identity_address.telephone;
            this.form.identity_address.province = customer.identity_address.province;
            this.form.identity_address.regency = customer.identity_address.regency;
            this.form.identity_address.district = customer.identity_address.district;
            this.form.identity_address.ownership_status = customer.identity_address.ownership_status;
            this.form.identity_address.fax = customer.identity_address.fax;

            this.form.has_set_investment_experience = customer.has_set_investment_experience;
            this.form.has_set_trading_simulation = customer.has_set_trading_simulation;
            this.form.has_confirm_costumer = customer.has_confirm_costumer;
            this.form.has_set_company_profile = customer.has_set_company_profile;
            this.form.has_set_mandate = customer.has_set_mandate;
            this.form.has_set_risk = customer.has_set_risk;
            this.form.has_set_trading_rules = customer.has_set_trading_rules;
            this.form.completeness_verification = customer.completeness_verification;
            this.form.disclosure_customer = customer.disclosure_customer;
            this.form.disclosure_risk = customer.disclosure_risk;
            this.form.disclosure_mandate = customer.disclosure_mandate;

            this.form.identity_type = customer.identity_type;
            this.bankType = res.data.data.bankType;
            this.form.fullname = customer.fullname;
            this.form.citizenship = customer.citizenship;
            this.form.date_of_birth = moment(customer.date_of_birth).format("YYYY-MM-DD");
            this.form.ktp_no = customer.ktp_no;
            this.form.mothers_name = customer.mothers_name;
            this.form.nickname = customer.nickname;
            this.form.place_of_birth = customer.place_of_birth;
            if (customer.ktp_issued_date) {
                this.form.ktp_issued_date = moment(customer.ktp_issued_date).format("YYYY-MM-DD");
            }
            this.form.npwp_no = customer.npwp_no;
            this.form.gender_code = customer.gender_type.code;
            this.marital_status.id = customer.marriage_type.code;
            this.marital_status.value = customer.marriage_type.name;
            this.form.marriage_code = customer.marriage_type.code;
            this.form.purpose_open_account_code = customer.purpose_open_account_type.code;
            this.form.has_investment_experience = customer.has_investment_experience;
            this.form.investment_experience = customer.investment_experience;

            this.form.has_futures_trading_family = customer.has_futures_trading_family;
            this.form.has_bankrupt = customer.has_bankrupt;
            this.form.partners_name = customer.partners_name;
            this.form.dependent_no = customer.dependent_no;

            this.form.domicile_address.address = customer.domicile_address.address;
            this.form.domicile_address.postcode = customer.domicile_address.postcode;
            this.form.domicile_address.neighborhood_no = customer.domicile_address.neighborhood_no;
            this.form.domicile_address.citizen_no = customer.domicile_address.citizen_no;
            this.form.domicile_address.village = customer.domicile_address.village;
            this.form.domicile_address.province = customer.domicile_address.province;
            this.form.domicile_address.regency = customer.domicile_address.regency;
            this.form.domicile_address.district = customer.domicile_address.district;

            if (customer.has_confirm_costumer) {
                this.setuju2 = 2;
                this.setuju = 1;
                this.form.has_confirm_costumer = true;
            }
        });

        // get profil
    },

    computed: {
        dataKYC() {
            return this.$store.getters.dataKYC;
        },
    },

    watch: {
        "dataProvince.code"() {
            if (this.dataProvince.code) {
                this.onCityKtp();
            }
        },
        "selectCityKtp.code"() {
            this.onDistrictsKtp();
        },
        "selectSubDistrictsKtp.code"() {
            this.subDistrictsKtp();
        },
        "dataProvinceDoms.code"() {
            this.onCityDomisili();
        },
        "dataCityDoms.code"() {
            this.onDistrictsDomisili();
        },
        "dataDistrictsDoms.code"() {
            this.onSubDistrictsDomisili();
        },
    },

    methods: {
        changeStatusInvestmentExperience(value) {
            this.investmentExperienceStatus = value;
        },
        selectedIdentity(e) {
            if (e.target.value == "600f83ca1ffe4968f75aeded") {
                this.identity_type = "KTP";
            } else if (e.target.value == "600f83ca1ffe4968f75aedf0") {
                this.identity_type = "SIM";
                this.data_keypress = 0;
                this.form.identity_owner = "";
            } else {
                this.identity_type = "Passport";
                this.data_keypress = 0;
                this.form.identity_owner = "";
            }
        },

        selectMarriage() {
            this.form.marriage_code = this.marital_status.id;
            if (this.marital_status.value == "Lajang") {
                this.form.partners_name = "";
            }
        },

        selctGender() {
            this.form.gender = this.data_gender.nama;
            this.form.gender_type = this.data_gender.id;
        },

        // profilPerusahaan() {
        //   let data = document.getElementsByName("confirmProfil");
        //   if (data[0].checked) {
        //     (this.setuju = 1), (this.selected = !this.selected);
        //     this.ifCheck = 200;
        //   } else {
        //     this.ifCheck = 403;
        //   }
        //   var id = document.getElementById("modal");
        //   id.scrollTop = 0;
        // },

        resiko() {
            let chek = [];
            let data = document.getElementsByName("chek");
            for (let i = 0; i < data.length; i++) {
                if (data[i].checked) {
                    chek.push(data[i].checked);
                }
            }
            if (chek.length != data.length) {
                this.ifCheck = 404;
            } else {
                this.setuju2 = 2;
                this.selected = !this.selected;
            }
        },

        onCityKtp() {
            this.form.identity_address.province_type = this.dataProvince.id;
            let id = this.dataProvince.code;
            axios.get("/v1/data/regency/" + id).then((res) => {
                this.cityKtp = res.data.data.body;
                for (let i = 0; i < this.cityKtp.length; i++) {
                    if (this.cityKtp[i]._id == this.selectCityKtp.id) {
                        this.selectCityKtp.code = this.cityKtp[i].code;
                    }
                }
            });
        },

        onDistrictsKtp() {
            this.form.identity_address.regency_type = this.selectCityKtp.id;
            axios.get("/v1/data/district/" + this.selectCityKtp.code).then((res) => {
                this.districtsKtp = res.data.data.body;
                for (let i = 0; i < this.districtsKtp.length; i++) {
                    if (this.districtsKtp[i]._id == this.selectSubDistrictsKtp.id) {
                        this.selectSubDistrictsKtp.code = this.districtsKtp[i].code;
                    }
                }
            });
        },

        subDistrictsKtp() {
            this.form.identity_address.district_type = this.selectSubDistrictsKtp.id;
            let id = this.selectSubDistrictsKtp.code;
            axios.get("/v1/data/village/" + id).then((res) => {
                this.subDistricsKtp = res.data.data.body;
            });
        },

        domisiliSameKtp(e) {
            if (e.target.checked) {
                this.form.domicile_address.address = this.form.identity_address.address;
                this.form.domicile_address.province = this.form.identity_address.province;
                this.form.domicile_address.regency = this.form.identity_address.regency;
                this.form.domicile_address.district = this.form.identity_address.district;
                this.form.domicile_address.village = this.form.identity_address.village;
                this.form.domicile_address.neighborhood_no = this.form.identity_address.neighborhood_no;
                this.form.domicile_address.citizen_no = this.form.identity_address.citizen_no;
                this.form.domicile_address.postcode = this.form.identity_address.postcode;
            } else {
                this.form.domicile_address.address = "";
                this.dataProvinceDoms.code = "";
                this.dataProvinceDoms.id = "";
                this.dataCityDoms.code = "";
                this.dataCityDoms.id = "";
                this.dataDistrictsDoms.code = "";
                this.dataDistrictsDoms.id = "";
                this.form.domicile_address.neighborhood_no = "";
                this.form.domicile_address.citizen_no = "";
                this.form.domicile_address.village_type = "";
                this.form.domicile_address.postcode = "";
            }
        },

        onCityDomisili() {
            this.form.domicile_address.province_type = this.dataProvinceDoms.id;
            let id = this.dataProvinceDoms.code;
            axios.get("/v1/data/regency/" + id).then((res) => {
                this.cityDomisili = res.data.data.body;
                for (let i = 0; i < this.cityDomisili.length; i++) {
                    if (this.cityDomisili[i]._id == this.dataCityDoms.id) {
                        this.dataCityDoms.code = this.cityDomisili[i].code;
                    }
                }
            });
        },

        onDistrictsDomisili() {
            this.form.domicile_address.regency_type = this.dataCityDoms.id;
            let id = this.dataCityDoms.code;
            axios.get("/v1/data/district/" + id).then((res) => {
                this.districtsDoms = res.data.data.body;
                for (let i = 0; i < this.districtsDoms.length; i++) {
                    if (this.districtsDoms[i]._id == this.dataDistrictsDoms.id) {
                        this.dataDistrictsDoms.code = this.districtsDoms[i].code;
                    }
                }
                // this.onSubDistrictsDomisili();
            });
        },

        onSubDistrictsDomisili() {
            this.form.domicile_address.district_type = this.dataDistrictsDoms.id;
            let id = this.dataDistrictsDoms.code;
            axios.get("/v1/data/village/" + id).then((res) => {
                this.subDistricsDoms = res.data.data.body;
            });
        },

        registerKYC() {
            this.isLoading = true;
            if (this.form.has_futures_trading_family == null && this.form.has_bankrupt == null) {
                this.$toast.error("Pastikan semua inputan dan Pernyataan sudah terisi");
            } else {
                let methode;
                if (this.idCustomer) {
                    methode = {
                        url: "/v2/kyc/customer/" + this.idCustomer,
                        method: "PUT",
                        data: this.form,
                    };
                } else {
                    methode = {
                        url: "/v2/kyc/customer",
                        method: "POST",
                        data: this.form,
                    };
                }
                axios(methode)
                    .then((res) => {
                        let status = res.data.data.status_code;
                        if (status == "00") {
                            this.isLoading = false;
                            if (this.form.has_futures_trading_family || this.form.has_bankrupt) {
                                this.$router.push("/konfirmasi-pialang");
                            } else {
                                this.$router.push("/register-datakontak");
                            }
                        } else if (status == "2004") {
                            this.isLoading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>Data sudah di submit</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        } else {
                            this.$notify({
                                group: "foo",
                                title: "<h5>kesalahan sistem</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        console.log(error);
                        this.$notify({
                            group: "foo",
                            title: "Cek kembali inputan anda",
                            type: "error",
                            duration: 2000,
                        });
                    });
            }
        },

        keymonitor() {
            axios
                .post("/v1/user/ektp", {
                    no_ktp: this.form.identity_owner,
                })
                .then((res) => {
                    this.data_keypress = res.data.status;
                    this.form.address = res.data.data.alamat;
                    this.form.place_of_birth = res.data.data.tempat_lahir;
                    this.form.birthday = moment(res.data.data.tgl_lahir).format("YYYY-MM-DD");
                    return this.data_keypress;
                })
                .catch((error) => {
                    let data_error = error.response.status;
                    this.data_keypress = data_error;
                    return this.data_keypress;
                });
        },
        numberOnly() {
            var numberPattern = /\d+/g;
            this.form.identity_address.telephone = this.form.identity_address.telephone.match(numberPattern).join("");
        },
        isAlphabet(event) {
            let value = event.target.value;
            if (value) {
                value.match(/[a-zA-Z\s]/g).join("");
                event.target.value = value;
            }
        },
        isAlphabetSymbol(event) {
            event.match(/[a-zA-Z0-9\s,.-]/g).join("");
        },

        openModal(even) {
            this.selected = !this.selected;
            this.modalShow = even;
        },
        async getKyc() {
            return await axios.get("/v1/nasabah?data=customer");
        },
    },
};
</script>

<style scoped>
.li-active:nth-child(2)::before {
    border: dashed 1px #c59733;
}
.container-outline {
    width: 70%;
    /* background: #fff; */
}

.top-squence {
    width: 85%;
    border-radius: 10px 10px 0 0;
    margin: 0 auto;
    background: #000e22;
    padding: 29px 20px;
    font-size: 14px;
}

.form-error {
    font-size: 12px;
    margin: 5px 210px;
    color: #e74c3c;
}

.afiliasi {
    width: 100%;
    background: #2222;
    color: #ff6f00;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 62px;
    padding: 10px;
    height: 60px;
    line-height: 2.5;
}

.afiliasi img {
    width: 30px;
    margin-right: 10px;
}

.kecamatan {
    width: 39% !important;
    margin-right: 20px;
}

.rt-rw {
    font-size: 13px;
    margin-right: 10px;
}

.rw {
    margin-left: 22px;
}

.input-rt-rw {
    width: 10% !important;
    text-align: center;
}

.form-ttl-bagi {
    width: 23%;
    text-transform: lowercase;
}

.deactive {
    display: none;
}

.clickCheck {
    width: 17px;
    height: 20px;
    position: absolute;
    top: -7px;
    left: -2px;
    z-index: 3;
    cursor: pointer;
}

.npwpActive {
    display: block;
    transition: all 0.5s ease-out;
    position: relative;
    top: -20px;
}

.npwp-no {
    font-size: 14px;
}

.content-modal {
    background: white;
    width: 50%;
    margin: 5% auto;
    padding: 20px;
    border-radius: 10px;
}

.title-modal {
    height: 50px;
    font-size: 20px;
    font-weight: bold;
}

.close {
    margin-top: -32px;
}

.footer-modal {
    margin: 50px 22px 10px;
}

.footer-modal div {
    width: 100%;
    text-align: center;
    margin: 0 auto;
}

.show-content {
    display: none;
}

.modalActive {
    display: block;
}

.konfirmasi {
    font-size: 13px;
    margin: 50px 0 10px 0;
    width: 96.5%;
}

.konfirmasiYa {
    color: #2ecc71;
}

.konfirmsaiTidak {
    color: #e74c3c;
}

.input-bappebti {
    width: 20%;
    display: flex;
    justify-content: flex-end;
}

.form-platform {
    display: flex;
}

.input-babepti[type="radio"]:checked,
.input-babepti[type="radio"]:not(:checked) {
    position: absolute;
    left: -999999px;
    cursor: pointer;
}

.input-babepti[type="radio"]:checked + label {
    color: #c59733;
}

.label-babepti {
    width: 40px;
    cursor: pointer;
    font-weight: bold;
}

.bappebti {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
}

.label--checkbox {
    font-size: 13px;
    position: relative;
    margin-left: 20px;
}

.label-radio {
    width: 185px;
    cursor: pointer;
}

.outer {
    margin: 10px 25px 10px 15px;
}

.register {
    margin: 46px 0;
}

.pernyataan-bappebti {
    /* margin-bottom: 3rem; */
    display: block;
    width: 100%;
}

.form-checkbox {
    display: flex;
}

label {
    font-size: 14px;
    width: 205px;
    display: inline-block;
}

.detail-alamat {
    width: 175px;
    margin: 0 0 0 30px;
}

.form-input,
select {
    width: 73%;
    height: 45px;
    border-radius: 7px;
    border: none;
    text-transform: capitalize;
    color: #707070;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

select::first-letter,
select::first-line {
    text-transform: uppercase;
}

.form-input:focus,
select:focus {
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.tempat {
    width: 41%;
    margin: 0 25px 0 0;
}

.tanggal {
    width: 29%;
    background: transparent;
    border: none;
    padding-right: 10px;
    text-transform: lowercase;
}

.birtday {
    background: transparent;
    border: none;
    padding-right: 3px;
    width: 100%;
    text-transform: lowercase;
}

.birtday::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
}

.tanggal::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
}

.input-button {
    height: 50px;
    position: relative;
    display: inline-flex;
    align-items: center;
    border: none;
    background: #f8f9fe;
    border-radius: 10px;
    top: 0px;
    width: 29%;
}

.input-button::after {
    content: "";
    position: absolute;
    width: 49px;
    height: 48px;
    background: url("../assets/calendar.svg") no-repeat center #000e22;
    background-size: 22px;
    right: 0;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    border-left: inherit;
    cursor: pointer;
}

.pos-telepon {
    width: 25%;
}

.identitas {
    width: 20%;
    margin: 0 27px 0 0;
    background-position-x: 92%;
}

.no-identitas {
    width: 50%;
}

.form-ktp-bagi {
    width: 24%;
    margin-right: 30px;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}
.container {
    width: 90%;
    padding-top: 45px;
}

.nav-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 50px;
    position: relative;
    /* background-color: lightcyan; */
}

.list-root {
    list-style: none;
    width: 40%;
    padding: 15px;
    text-align: center;
    color: rgba(112, 112, 112, 0.5);
}

.active {
    border-top-right-radius: 15px;
    background-color: #c59733;
    color: white;
    position: relative;
    text-align: center;
    position: absolute;
    width: 20%;
    top: -54px;
}

.active:first-child {
    border-top-left-radius: 15px;
}

.active:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 0;
}

input:disabled,
select:disabled {
    cursor: not-allowed;
}

.active::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 65px;
    background-color: #1f354a;
    top: -2px;
    left: -41px;
    border: 2px solid #000e22;
}

.active:first-child::before {
    opacity: 0;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid #1f354a;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

.konfirmasi-ktp {
    width: 54%;
    position: relative;
    margin-left: auto;
}

.tanggal-aktif {
    width: 22%;
    text-transform: lowercase;
}

.identityActive {
    width: 20%;
    margin-right: 2%;
    /* display: none; */
}

.masa-aktif {
    font-size: 13px;
    margin-right: 10px;
}

.activeForm {
    display: inline-block;
}

@media (min-width: 768px) and (max-width: 1190px) {
    .list-root {
        font-size: 13px;
    }
    .active {
        padding: 10px;
        text-align: center;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active::before {
        width: 28px;
        left: -25px;
    }

    label,
    select,
    .form-input,
    .detail-alamat {
        width: 100%;
    }

    .tempat {
        width: 55%;
    }
    .tanggal {
        width: 31%;
    }
    .identitas {
        width: 35%;
    }

    .no-identitas {
        width: 60%;
    }

    .provincy,
    .city,
    .kecamatan {
        margin-left: 30px;
        width: 94.5%;
    }

    .kode-pos {
        margin-left: 30px;
        width: 25%;
    }

    .input-button {
        right: 0;
        width: 40%;
        top: 30px;
    }
}

@media (max-width: 768px) {
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        margin-left: 10px;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .form-error {
        margin-left: 0;
    }

    .bappebti span {
        width: 100%;
    }

    .radio{
        display: flex;
        justify-content: space-between
    }

    .radio label{
        width: unset
    }
}
</style>
